import { render } from "solid-js/web";
import { Router, Route } from "@solidjs/router";

import App from "./App";
import Admin from "./routes/Admin";
import Api from "./routes/Api";
import Dashboard from "./routes/Dashboard";
import Firms from "./routes/Firms";
import Firm from "./routes/Firm";
import Login from "./routes/Login";
import Sectors from "./routes/Sectors";
import ThankYou from "./routes/ThankYou";
import "./styles.css";

const root = document.getElementById("root");
if (!root) throw new Error("root element missing");

render(
  () => (
    <Router root={App}>
      <Route path="/dashboard" component={Dashboard} />
      <Route path="/firms" component={Firms} />
      <Route path="/sectors" component={Sectors} />
      <Route path="/firm/:slug" component={Firm} />
      <Route path="/api" component={Api} />
      <Route path="/thank-you" component={ThankYou} />
      <Route path="/login" component={Login} />
      <Route path="/admin" component={Admin} />
    </Router>
  ),
  root,
);
